<script setup>
import {ref, computed} from "vue";
import axios from "axios";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

const projects = ref([]);
const competition = ref(undefined);
const competitions = ref([]);
const categories = ref([]);
const fpgRequest = ref({});
const fbgCategoryId = ref(null);
const isLoading = ref(false);
const tab = ref('1');

async function getData() {
  isLoading.value = true;
	if (window.competitionId && window.competitionId !== '0') {
		const response = await axios.get('/api/competitions/' + window.competitionId);
		competition.value = response.data;
	}
  try {
    const response = await axios.get('/project/getProjectsByType/complete');
    projects.value = response.data;
  } catch (error) {
    console.log(error);
  }
  
  if (projects.value.length > 0) {
      try {
          const response = await axios.get(`/competition/apiGetCompetitions/${projects.value[0].id}`);
          competitions.value = response.data;
        } catch (error) {
      	  console.log(error);
        }
  }
  
  
  isLoading.value = false;
}

getData();

const isProjectAdded = (project, competition) => {
  // Логика проверки, добавлен ли проект в конкурс
  // Нужно реализовать в соответствии с вашими требованиями
};
function getProjectAvatar(avatar) {
  return ImageService.getProjectImagePath(avatar);
}

function setCompetition(val) {
  console.log('333');
	competition.value = val;
  tab.value = '2';
}

const tab2Name = computed(() => {
  if (!competition.value) {
    return 'Шаблоны проектов';
	} else {
		return 'Проекты';
  }
})

</script>

<template>
	<div v-if="!isLoading">

    <template v-if="competition">
      <p style=" margin-bottom: 35px;"><a class="button2" :href="'project/new_complete'+competition.id">Добавить новый проект</a></p>
    </template>
		<template v-else>
      <p style=" margin-bottom: 35px;"><a class="button2" :href="'/project/new_complete'">Добавить новый проект</a></p>
		</template>
		
    <a-tabs @change="onTabChange" v-model:activeKey="tab">
      <a-tab-pane key="1" tab="Заявки на конкурсы">
        <div v-for="competition in competitions.competitions" :key="competition.id">
	        <p>{{ competition.name }} - <a :data-competitionId="competition.id" @click.prevent="setCompetition(competition)">Выбрать</a></p>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="tab2Name">
	      <div style="margin-bottom: 20px;" v-if="competition">Проекты для подачи на конкурс <strong>"{{ competition.name }}"</strong></div>
        <div  class="columns is-multiline projects_columns" v-if="projects.length">
          <div v-for="project in projects" :key="project.id" class="column is-6">
            <div class="columns">
              <div class="column is-narrow">
                <ImageRender class-name="tizer_image" :src="getProjectAvatar(project.afisha)"></ImageRender>
              </div>
              <div class="column project-information">
                <div class="project-information1">
                  <template v-if="competition && competition.name && competition.napravlenie !== 'Кинофестиваль'">
                    <span v-if="isProjectAdded(project, competition)" class="order-send">Заявка отправлена</span>
                    <div v-else>
                      <template v-if="fpgRequest">
                        <p class="send-order-wrapper">
                          <a class="send-order"
                             :href="`/competition/addproject/${competition.id}/${project.id}/${fbgCategoryId}/${fpgRequest.id}`">
                            Подать заявку в категорию «{{
												      fpgRequest.type === 'outside' ? 'Взгляд снаружи' : 'Взгляд изнутри'
                            }}»
                          </a>
                        </p>
                      </template>
                      <template v-else>
                        <p v-for="category in categories" :key="category.id" class="send-order-wrapper">
                          <a class="send-order"
                             :href="`/competition/addproject/${competition.id}/${project.id}/${category.id}`">
                            Подать заявку в категорию "{{ category.name }}"
                          </a>
                        </p>
                      </template>
                    </div>
                  </template>
                </div>
                <div class="project-information2">
                  <template v-if="!competition">
                    <p><a :href="`/project/${project.id}/update_complete`">{{ project.name }}</a></p>
                    <div class="menu-items-block">
                      <a :href="`/project/${project.id}/update_complete`"><i class="far fa-edit"></i></a>
                      <a class="delete_link" :href="`/project/delete/${project.id}`"><i class="far fa-trash-alt"></i></a>
                    </div>
                  </template>
                  <template v-else>
                    <p><a :href="`/project/${project.id}/update_complete`">{{ project.name }}</a></p>
                    <p style="margin-top: 30px;">
                      <a :href="`/project/${project.id}/update_complete/${competition.id}`" class="button4">Подать
                        заявку</a>
                    </p>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>Нет записей</div>
      </a-tab-pane>
    </a-tabs>
		
	</div>
	<a-spin v-else></a-spin>
</template>

<style scoped>
.menu-items-block {
    display: flex;
}
.menu-items-block i {
    margin-left: 0;
}
.projects_columns:deep .tizer_image {
    max-width: 165px;
    width: 90%;
}
.project-information {
    display: flex; flex-direction: column
}
.project-information .project-information1 {
    flex-grow: 1;
}
.project-information2 {
    font-family: "Roboto",sans-serif;
    font-weight: 700;
    font-size: 16px;
}

.send-order {
    font-weight: 700;
    font-size: 13px;
    line-height: normal;
    color: #555555;
}
.send-order-wrapper {
    line-height: normal;
}
.order-send {
    font-family: "Roboto", sans-serif;
    font-weight: bold;
    font-size: 14px;
    color: #AFAFAF;
}
.first-block {
    margin-bottom: 90px;
}
.project-information2 p a {
    color: #4a4a4a;
}
.question_mark {
    font-size: 30px;
    position: absolute;
    right: 40px;
    top: 10px;
    cursor: pointer;
}
.question_mark i {
    color: #F69F22;
}
</style>